import { CustomerSelection } from "../../CheckoutCustomer/CustomerSelection";
import { useCheckoutHelper } from "../../../../../hooks/useCheckoutHelper";

export const PRPayment = () => {
  const { customer, setCustomerInfo } = useCheckoutHelper();
  const customerInfo = customer;

  return (
    <section>
      <h5>Public Relations</h5>

      <CustomerSelection
        customerInfo={customerInfo}
        setCustomerInfo={(data) => {
          setCustomerInfo(data);
        }}
      />
    </section>
  );
};
